import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ml-16" }
const _hoisted_2 = { class: "ml-16" }
const _hoisted_3 = { class: "ml-16" }
const _hoisted_4 = { class: "ml-16" }
const _hoisted_5 = { class: "ml-16" }
const _hoisted_6 = { key: 0 }

import { Category } from '@/models/category.model';
import { User } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { CategoriesActions, CategoriesState } from '@/stores/categories.store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, onMounted, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserBPT',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  emits: ['reset'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore<
  ShiftCMSState & { us: UsersState; cs: CategoriesState }
>();

const emit = __emit;

const categories = computed<Category[]>(() => store.state.cs.categories);
const interests = computed<Category[]>(() => store.state.us.interests);

function resetBPT() {
  if (confirm(`Are you sure you want to reset this user's BPT information`)) {
    store.dispatch(UsersActions.ResetBPT, props.user);

    emit('reset');
  }
}

onMounted(() => {
  store.dispatch(CategoriesActions.GetCategories);
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!

  return (__props.user.bptInfo)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createTextVNode("Behaviour and Profile Tracker ")),
              _createVNode(_component_v_btn, {
                color: "warning",
                onClick: resetBPT
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Reset")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          (interests.value && interests.value.length)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Interests", -1)),
                  _createElementVNode("ul", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interests.value, (interest) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: interest.id
                      }, _toDisplayString(interest.title), 1))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.user.bptInfo.expertise.length)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Expertise", -1)),
                  _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.user.bptInfo.expertise, (expertise) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: expertise.categoryId
                      }, [
                        _createTextVNode(_toDisplayString(categories.value.find((c) => c.id === expertise.categoryId)?.title) + " ", 1),
                        _createVNode(_component_v_chip, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(expertise.level), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.user.bptInfo.motivation.length)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 2 }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Motivation", -1)),
                  _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.user.bptInfo.motivation, (mot) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: mot.option
                      }, [
                        _createVNode(_component_v_chip, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mot.option), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(mot.openAnswer), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.user.bptInfo.behavior.length)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 3 }, {
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Behavior", -1)),
                  _createElementVNode("ul", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.user.bptInfo.behavior, (beh) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: beh.option
                      }, [
                        _createVNode(_component_v_chip, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(beh.option), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(beh.openAnswer), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.user.bptInfo.barriers.length)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 4 }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("h4", null, "Barriers", -1)),
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.user.bptInfo.barriers, (bar) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: bar.option
                      }, [
                        _createVNode(_component_v_chip, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(bar.option), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(bar.openAnswer), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (
          !(
            __props.user.bptInfo.expertise.length &&
            __props.user.bptInfo.motivation.length &&
            __props.user.bptInfo.behavior.length &&
            __props.user.bptInfo.barriers.length
          )
        )
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " User has not filled out any BPT information "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})